package org.bsvac.bsvac_kmp.ui

import androidx.compose.foundation.background
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.BoxScope
import androidx.compose.foundation.layout.size
import androidx.compose.foundation.layout.wrapContentSize
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.runtime.LaunchedEffect
import androidx.compose.runtime.getValue
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.setValue
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import org.bsvac.bsvac_kmp.data.BsvacTextStyle
import org.bsvac.bsvac_kmp.data.models.AgencyModel
import org.bsvac.bsvac_kmp.data.models.AmbulanceUnitModel
import org.bsvac.bsvac_kmp.data.models.BoroughModel
import org.bsvac.bsvac_kmp.data.models.ContentSectionId
import org.bsvac.bsvac_kmp.data.models.CrewModel
import org.bsvac.bsvac_kmp.data.models.RadioModel
import org.bsvac.bsvac_kmp.data.models.TourModel
import org.bsvac.bsvac_kmp.ui.models.Choices
import org.bsvac.bsvac_kmp.ui.subscreens.LogonSubScreen
import org.bsvac.bsvac_kmp.ui.models.LogonSubScreenModel
import org.bsvac.bsvac_kmp.ui.models.OnSelection
import org.bsvac.bsvac_kmp.ui.models.Selected
import org.bsvac.bsvac_kmp.ui.subscreens.errorDialog
import org.jetbrains.compose.ui.tooling.preview.Preview
import org.jetbrains.compose.ui.tooling.preview.PreviewParameter
import org.jetbrains.compose.ui.tooling.preview.PreviewParameterProvider

object SubScreens {
    fun content(modifier: Modifier = Modifier,
                displayError: String? = null,
                sectionId: ContentSectionId,
                errorDisplayed: () -> Unit = {},
                logonSubScreenModel: LogonSubScreenModel,
                ): @Composable (BoxScope.() -> Unit) {
        return {
            var displayError by remember(displayError) {
                mutableStateOf(displayError)
            }
            when(sectionId) {
                ContentSectionId.LOGON -> {
                    LogonSubScreen(scope = this,logonSubScreenModel)
                }

                else -> {

                    Text(
                        sectionId.title,
                        modifier = modifier.wrapContentSize().background(Color.White).align(alignment = Alignment.Center)
                    )
                }
            }
            displayError?.let { errorMessage ->
                errorDialog(modifier = modifier, errorMessage = errorMessage)()
                LaunchedEffect(key1 = displayError) {
                    errorDisplayed()
                }
            }
        }
    }
}

@Composable
@Preview
fun PreviewSubScreens(@PreviewParameter(SubScreenPreviewProvider::class) sectionId: ContentSectionId) {
    val logonSubScreenModel = LogonSubScreenModel(
        bsvacTextStyle = BsvacTextStyle(15.sp),
        choices = Choices(
            agencyOptions = AgencyModel.entries,
            boroughOptions = BoroughModel.entries,
            crewMemberOptions = CrewModel.entries,
            unitOptions = AmbulanceUnitModel.entries,
            tourOptions = TourModel.entries,
            radioOptions = RadioModel.entries,
        ),
        onSelection = OnSelection(
            onAgencySelected = {},
            onCrewMemberSelected = { _,_ -> },
            onBoroughSelected = {},
            onAmbulanceUnitSelected = {},
            onTourSelected = {},
            onRadioSelected = { _,_ -> },
        ),
        selected = Selected()
    )
    Box(modifier = Modifier.size(800.dp)) {
        SubScreens.content(
            modifier = Modifier,
            sectionId = sectionId,
            displayError = "Hey",
            logonSubScreenModel = logonSubScreenModel,
            ).invoke(this)
    }
}

class SubScreenPreviewProvider : PreviewParameterProvider<ContentSectionId> {
    override val values = ContentSectionId.entries.asSequence()
    override val count: Int = values.count()
}